export const formatPostalCode = (input: string, space = false) => {
  // makes uppercase, and removes non-alphanumeric characters
  let postalCode = input.toUpperCase().replace(/\W/g,'');

  // adds space after third character if desired, trims to desired length
  if (space && input.length > 5) {
    postalCode = postalCode.replace(/(...)/,'$1 ');
  }

  if (space) {
    return postalCode.slice(0,7);
  }

  return postalCode.slice(0,6);
};
